import { render, staticRenderFns } from "./DestinationPreset.vue?vue&type=template&id=288c82d4&scoped=true&"
import script from "./DestinationPreset.vue?vue&type=script&lang=js&"
export * from "./DestinationPreset.vue?vue&type=script&lang=js&"
import style0 from "./DestinationPreset.vue?vue&type=style&index=0&id=288c82d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288c82d4",
  null
  
)

export default component.exports